import { Box } from "@mui/material"
import { CategoryModal } from "./CategoryModal"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CategoryData } from "../../types";

interface AddCategoryProps {
  refetchCategories: () => void;
  categories: CategoryData[];
}

export const AddCategory = ({refetchCategories, categories}: AddCategoryProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/categories');
  }

  const handleSave = () => {
    navigate('/categories');
    refetchCategories();
  }
  
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="add-category">
      <CategoryModal open={open} handleClose={handleClose} category={{  }} handleSave={handleSave} categories={categories} />
    </Box>
  )
}